import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    organizationSwitcherContainer: {
        justifyContent: "center",
        minWidth: 180
    },
    selectBox: {
        marginBottom: 0,
        marginTop: 0
    }
});
export default stylesheet;
